export const urlValidator = (val: string): boolean =>
  /^(https?:\/\/)?([\da-z.-]+)\.([a-z.]{2,6})([/\w .-]*)*\/?/u.test(val);

// Ensure the URL starts with https://
export const urlTransformer = (url: string): string => {
  if (url.startsWith('https://')) {
    return url;
  }

  if (url.startsWith('http://')) {
    return url.replace('http://', 'https://');
  } else {
    return `https://${url}`;
  }
};

export const definedKeyValueValidator = (val: Array<{key?: string; value?: string}>): boolean => {
  return val.every(({key, value}) => {
    return key !== undefined && value !== undefined;
  });
};
